import { bopApi } from '@/lib/api/client';

const REPORTS_PATH = 'v1/reports';
const PRESIGNED_URL_PATH = 'v1/s3/presigned-url';

// The wire type: every type the API accepts, whether or not the Reports page offers it
export type ReportType =
  | 'solidus'
  | 'solidus-midas'
  | 'mifir'
  | 'mifir-venue'
  | 'emir'
  | 'emir-margins'
  | 'rts23'
  | 'fiu-utr'
  | 'firds'
  | 'account-audit'
  | 'dac8-audit'
  | 'account-cleanup'
  | 'fee-run';

// What the Reports page offers: 'firds' is deliberately left out, and the internal reports
// ('account-audit', 'dac8-audit', 'account-cleanup', 'fee-run') have their own pages under User Audit, DAC8 and Fee Collection
export const REPORT_TYPE_OPTIONS: ReadonlyArray<{ value: ReportType; label: string }> = [
  { value: 'solidus', label: 'Solidus' },
  { value: 'solidus-midas', label: 'Solidus Midas' },
  { value: 'mifir', label: 'MiFIR' },
  { value: 'mifir-venue', label: 'MiFIR Venue' },
  { value: 'emir', label: 'EMIR' },
  { value: 'emir-margins', label: 'EMIR Margins' },
  { value: 'rts23', label: 'RTS23' },
  { value: 'fiu-utr', label: 'FIU UTR Filings' },
];

export interface ReportFile {
  key: string;
  size: number;
  /** ISO-8601 */
  lastModified: string;
}

export interface ReportsResponse {
  type: string;
  from: string;
  to: string;
  files: ReportFile[];
}

export interface PresignedUrlResponse {
  url: string;
  expiresIn: number;
}

export interface ReportsQuery {
  type: ReportType;
  /** YYYY-MM-DD */
  from: string;
  /** YYYY-MM-DD */
  to: string;
}

export const getReports = ({ type, from, to }: ReportsQuery) => bopApi.get(REPORTS_PATH, { searchParams: { type, from, to } }).json<ReportsResponse>();

export const getPresignedUrl = (key: string) => bopApi.get(PRESIGNED_URL_PATH, { searchParams: { key } }).json<PresignedUrlResponse>();
